var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExpand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "zoom_out_map_black_24dp",
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2693",
    "data-name": "Caminho 2693",
    d: "M0,0H22V22H0Z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2694",
    "data-name": "Caminho 2694",
    d: "M14.045,3l2.117,2.117L13.5,7.759l1.307,1.307,2.642-2.66,2.117,2.117V3ZM3,8.523,5.117,6.406l2.642,2.66L9.066,7.759,6.406,5.117,8.523,3H3ZM8.523,19.568,6.406,17.451l2.66-2.642L7.759,13.5l-2.642,2.66L3,14.045v5.523Zm11.045-5.523-2.117,2.117L14.809,13.5,13.5,14.809l2.66,2.642-2.117,2.117h5.523Z",
    transform: "translate(-0.284 -0.284)",
    fill: "#00a2e0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpand);
export default __webpack_public_path__ + "static/media/expand.0a7f8455.svg";
export { ForwardRef as ReactComponent };